import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

/** @param {any} props */
export default function Divider({
  className = null,
  containerClassName = 'container-xxl'
}) {
  return (
    <div className={classnames('Divider', containerClassName)}>
      <hr className={classnames('b--solid b--default bt-0', className)} />
    </div>
  );
}

Divider.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string
};
